module.exports = __webpack_public_path__ + "static/media/slide2.4580f833.jpg";